export const LANDING_PAGE_URL = 'https://hml-ai.angellira.cloud/';
